import { render } from "./information.vue?vue&type=template&id=6d04e0b0&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"

import "./information.vue?vue&type=style&index=0&id=6d04e0b0&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\gurmi\\Projects\\anyform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d04e0b0"]])

export default __exports__